import React, { useMemo } from "react";
import { Alert, Box } from "@mui/material";

const appendVariable = (params, name, value) => {
  const paramName = name === "from" || name === "to" ? name : `var-${name}`;

  if (Array.isArray(value)) {
    value.forEach((item) => {
      if (item !== null && item !== undefined) {
        params.append(paramName, String(item));
      }
    });
    return;
  }

  if (value !== null && value !== undefined) {
    params.append(paramName, String(value));
  }
};

export const GrafanaPanel = ({ panel, runtime, values = {}, grafanaAuth }) => {
  const src = useMemo(() => {
    if (
      !runtime?.embed_base_url ||
      !runtime?.uid ||
      !runtime?.slug ||
      !runtime?.org_id ||
      !panel?.panel_id ||
      !grafanaAuth
    ) {
      return null;
    }

    const params = new URLSearchParams();
    params.set("orgId", String(runtime.org_id));
    params.set("panelId", String(panel.panel_id));

    Object.entries(values).forEach(([name, value]) => {
      if (name !== "grafana_auth") appendVariable(params, name, value);
    });

    params.set("var-grafana_auth", grafanaAuth);

    return `${runtime.embed_base_url}/d-solo/${encodeURIComponent(
      runtime.uid
    )}/${encodeURIComponent(runtime.slug)}?${params.toString()}`;
  }, [panel?.panel_id, runtime, values, grafanaAuth]);

  if (!src) {
    return (
      <Alert severity="warning" sx={{ height: "100%", boxSizing: "border-box" }}>
        El panel no tiene configuración suficiente o autorización vigente para renderizarse.
      </Alert>
    );
  }

  return (
    <Box sx={{ width: "100%", height: "100%", overflow: "hidden" }}>
      <iframe
        title={panel.titulo || `Panel ${panel.panel_id}`}
        src={src}
        width="100%"
        height="100%"
        frameBorder="0"
        scrolling="no"
        style={{
          display: "block",
          border: 0,
          overflow: "hidden",
        }}
      />
    </Box>
  );
};
